import { Component, Input, ViewChild, OnInit, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-faq',
    templateUrl: 'faq.component.html',
    styleUrls: ['faq.component.css'],
    standalone: false
})
export class FaqComponent implements OnInit,AfterViewInit {
    message: any;
    videoRef:any;
    constructor() { }

    ngOnInit() {
        this.videoRef = document.querySelector('video');
    }
    closeVideo(){
        this.videoRef.pause();
    }
    scrollToElement($element): void {
        $element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
    ngAfterViewInit(): void {
        let el = document.querySelector('.toptoscroll');
        el.scrollIntoView({behavior:"smooth"});
        //window.scrollTo(20, document.body.scrollHeight || document.documentElement.scrollHeight);
      }

    togglePanel(id) {
        var acc = document.getElementsByClassName("accordion");

        for (var i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }
}  